module.exports = __webpack_public_path__ + "static/en-3-ee9130625565f85e0f0cd1df5278a06b.png";